// assets/ring-size-guide.js
(() => {
  const OPEN_SEL = "[data-ring-size-guide-open]";
  const DIALOG_SEL = "[data-ring-size-guide-dialog]";
  const CLOSE_SEL = "[data-ring-size-guide-close]";
  const METHOD_INPUT_SEL = "[data-ring-size-guide-method]";
  const PANEL_SEL = "[data-ring-size-guide-panel]";

  function openDialog(dialog) {
    if (!dialog) return;
    if (typeof dialog.showModal === "function") dialog.showModal();
    else dialog.setAttribute("open", ""); // fallback
    dialog.classList.add("is-open");
  }

  function closeDialog(dialog) {
    if (!dialog) return;
    dialog.classList.remove("is-open");
    if (typeof dialog.close === "function") dialog.close();
    else dialog.removeAttribute("open");
  }

  function setActivePanel(dialog, value) {
    const panels = dialog.querySelectorAll(PANEL_SEL);
    panels.forEach((p) => {
      const isActive = p.getAttribute("data-ring-size-guide-panel") === value;
      p.toggleAttribute("hidden", !isActive);
    });
  }

  function initOne(root) {
    const dialog = root.querySelector(DIALOG_SEL);
    if (!dialog) return;

    // OPEN
    root.querySelectorAll(OPEN_SEL).forEach((btn) => {
      if (btn.dataset.rsgBound === "true") return;
      btn.dataset.rsgBound = "true";
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        openDialog(dialog);

        // ilk seçili paneli göster
        const checked = dialog.querySelector(`${METHOD_INPUT_SEL}:checked`);
        if (checked) setActivePanel(dialog, checked.value);
      });
    });

    // CLOSE (X butonu)
    dialog.querySelectorAll(CLOSE_SEL).forEach((btn) => {
      if (btn.dataset.rsgBound === "true") return;
      btn.dataset.rsgBound = "true";
      btn.addEventListener("click", () => closeDialog(dialog));
    });

    // dışarı tıklayınca kapansın
    dialog.addEventListener("click", (e) => {
      if (e.target === dialog) closeDialog(dialog);
    });

    // ESC zaten native dialog’da kapanır (fallback’te de kapatalım)
    dialog.addEventListener("keydown", (e) => {
      if (e.key === "Escape") closeDialog(dialog);
    });

    // METHOD change
    dialog.querySelectorAll(METHOD_INPUT_SEL).forEach((input) => {
      if (input.dataset.rsgBound === "true") return;
      input.dataset.rsgBound = "true";
      input.addEventListener("change", () => setActivePanel(dialog, input.value));
    });

    // ilk render
    const checked = dialog.querySelector(`${METHOD_INPUT_SEL}:checked`);
    if (checked) setActivePanel(dialog, checked.value);
  }

  function init(root = document) {
    root.querySelectorAll("[data-ring-size-guide]").forEach(initOne);
  }

  document.addEventListener("DOMContentLoaded", () => init(document));
  document.addEventListener("shopify:section:load", (e) => init(e.target));

  // load more / ajax için
  const obs = new MutationObserver((muts) => {
    for (const m of muts) {
      for (const node of m.addedNodes) {
        if (!(node instanceof HTMLElement)) continue;
        if (node.matches?.("[data-ring-size-guide]")) initOne(node);
        node.querySelectorAll?.("[data-ring-size-guide]").forEach(initOne);
      }
    }
  });
  document.addEventListener("DOMContentLoaded", () => {
    obs.observe(document.body, { childList: true, subtree: true });
  });
})();
